import { BREAK_POINTS, GAME_CARD_VARIANTS } from 'constants/uiConfig'

export const CONTROL_POSITION = {
  TOP: 'top',
  BOTTOM: 'bottom',
  LEFT_RIGHT: 'left_right'
}

export const SLIDE_TYPES = {
  GAME_CARD: 'gameCard',
  TOURNAMENT_GAMES_CARD: 'tournamentGamesCard',
  LOYALTY_CARDS: 'loyaltyCard',
  AVAILABLE_GAMES: 'availableGames',
  AUTH_BANNER: 'authBanner',
  VIP_LEVEL_CARDS: 'vipLevelCards',
  BENEFITS_STRIP: 'benefitsStrip'
}

// Base configuration for slides to show
export const BASE_SLIDES_TO_SHOW_CONFIG = {
  [GAME_CARD_VARIANTS.V1]: {
    [BREAK_POINTS.xl]: 6,
    [BREAK_POINTS.xlm]: 6,
    [BREAK_POINTS.lg]: 5.1,
    [BREAK_POINTS.md]: 3.4,
    [BREAK_POINTS.sm]: 3.1,
    [BREAK_POINTS.xs]: 1.6
  },
  [GAME_CARD_VARIANTS.V2]: {
    [BREAK_POINTS.xl]: 6.3,
    [BREAK_POINTS.xlm]: 5.6,
    [BREAK_POINTS.lg]: 4.7,
    [BREAK_POINTS.md]: 3.5,
    [BREAK_POINTS.sm]: 3,
    [BREAK_POINTS.xs]: 3
  },
  [GAME_CARD_VARIANTS.V3]: {
    [BREAK_POINTS.xl]: 8,
    [BREAK_POINTS.xlm]: 8,
    [BREAK_POINTS.lg]: 7,
    [BREAK_POINTS.md]: 5,
    [BREAK_POINTS.sm]: 4,
    [BREAK_POINTS.xs]: 3
  },
  [SLIDE_TYPES.AVAILABLE_GAMES]: {
    [BREAK_POINTS.xl]: 1.5,
    [BREAK_POINTS.xlm]: 1.5,
    [BREAK_POINTS.lg]: 1.4,
    [BREAK_POINTS.md]: 1.3,
    [BREAK_POINTS.sm]: 1.3,
    [BREAK_POINTS.xs]: 1.3
  },
  [SLIDE_TYPES.LOYALTY_CARDS]: {
    [BREAK_POINTS.xl]: 3,
    [BREAK_POINTS.xlm]: 2.7,
    [BREAK_POINTS.lg]: 2.3,
    [BREAK_POINTS.md]: 1.7,
    [BREAK_POINTS.sm]: 1.15,
    [BREAK_POINTS.xs]: 1
  },
  [SLIDE_TYPES.TOURNAMENT_GAMES_CARD]: {
    [BREAK_POINTS.xl]: 4.3,
    [BREAK_POINTS.xlm]: 4.3,
    [BREAK_POINTS.lg]: 4.1,
    [BREAK_POINTS.md]: 3.1,
    [BREAK_POINTS.sm]: 2.1,
    [BREAK_POINTS.xs]: 2.1
  },
  [SLIDE_TYPES.AUTH_BANNER]: {
    [BREAK_POINTS.xl]: 1,
    [BREAK_POINTS.xlm]: 1,
    [BREAK_POINTS.lg]: 1,
    [BREAK_POINTS.md]: 1,
    [BREAK_POINTS.sm]: 1,
    [BREAK_POINTS.xs]: 1
  },
  [SLIDE_TYPES.BENEFITS_STRIP]: {
    [BREAK_POINTS.xl]: 3,
    [BREAK_POINTS.xlm]: 3,
    [BREAK_POINTS.lg]: 3,
    [BREAK_POINTS.md]: 3,
    [BREAK_POINTS.sm]: 1,
    [BREAK_POINTS.xs]: 1
  }
}

// Slides-to-show overrides keyed by abstract names (referenced via slidesToShowOverride
// in the tenant JSON config). Use override_1, override_2, etc. — never tenant names.
export const TENANT_SLIDES_TO_SHOW_OVERRIDES = {
  override_1: {
    [GAME_CARD_VARIANTS.V2]: {
      [BREAK_POINTS.xl]: 6,
      [BREAK_POINTS.xlm]: 6,
      [BREAK_POINTS.lg]: 5,
      [BREAK_POINTS.md]: 4,
      [BREAK_POINTS.sm]: 3,
      [BREAK_POINTS.xs]: 3
    }
  }
  // Add more overrides here as needed, e.g.:
  // override_2: {
  //   [GAME_CARD_VARIANTS.V2]: {
  //     [BREAK_POINTS.xl]: 8,
  //     [BREAK_POINTS.xlm]: 7,
  //     [BREAK_POINTS.lg]: 6,
  //     [BREAK_POINTS.md]: 4,
  //     [BREAK_POINTS.sm]: 3,
  //     [BREAK_POINTS.xs]: 2
  //   }
  // }
}

export const SLIDES_TO_SCROLL_CONFIG = {
  v1: {
    [BREAK_POINTS.xl]: 5,
    [BREAK_POINTS.xlm]: 5,
    [BREAK_POINTS.lg]: 5,
    [BREAK_POINTS.md]: 4,
    [BREAK_POINTS.sm]: 3,
    [BREAK_POINTS.xs]: 2
  },
  v2: {
    [BREAK_POINTS.xl]: 5,
    [BREAK_POINTS.xlm]: 5,
    [BREAK_POINTS.lg]: 3,
    [BREAK_POINTS.md]: 3,
    [BREAK_POINTS.sm]: 2,
    [BREAK_POINTS.xs]: 1
  },
  v3: {
    [BREAK_POINTS.xl]: 5,
    [BREAK_POINTS.xlm]: 5,
    [BREAK_POINTS.lg]: 5,
    [BREAK_POINTS.md]: 4,
    [BREAK_POINTS.sm]: 3,
    [BREAK_POINTS.xs]: 2
  },
  [SLIDE_TYPES.AVAILABLE_GAMES]: {
    [BREAK_POINTS.xl]: 1,
    [BREAK_POINTS.xlm]: 1,
    [BREAK_POINTS.lg]: 1,
    [BREAK_POINTS.md]: 1,
    [BREAK_POINTS.sm]: 1,
    [BREAK_POINTS.xs]: 1
  },
  [SLIDE_TYPES.TOURNAMENT_GAMES_CARD]: {
    [BREAK_POINTS.xl]: 4,
    [BREAK_POINTS.xlm]: 4,
    [BREAK_POINTS.lg]: 4,
    [BREAK_POINTS.md]: 3,
    [BREAK_POINTS.sm]: 2,
    [BREAK_POINTS.xs]: 2
  },
  [SLIDE_TYPES.AUTH_BANNER]: {
    [BREAK_POINTS.xl]: 1,
    [BREAK_POINTS.xlm]: 1,
    [BREAK_POINTS.lg]: 1,
    [BREAK_POINTS.md]: 1,
    [BREAK_POINTS.sm]: 1,
    [BREAK_POINTS.xs]: 1
  }
}
